export const AUTH_TOKEN = 'sentry-REPLACE_ME-token';
export const RENEWAL_TOKEN = 'sentry-REPLACE_ME-r-token';
export const VUEX_STORE = 'sentry-s-REPLACE_ME';
export const LANGUAGE = 'sentry-language-variation';

export const EXCLUDE_KEYS = ['notification'];
